// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__xzs-7","buttons":"RemoveExpirationActionButtons_buttons__2d9ez"};